import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";

import userReducer from "./redux/reducers/user";
import DashboardReducer from "./redux/reducers/dashboard";
import CompanyReducer from "./redux/company/company-slice";
import companyPermissionsReducer from "./redux/company-permissions/company-permissions-slice";
import companyAdditionalFieldsReducer from "./redux/company-additional-fields/company-additional-fields-slice";

const rootReducer = combineReducers({
  user: userReducer,
  dashboard: DashboardReducer,
  company: CompanyReducer,
  companyPermissions: companyPermissionsReducer,
  companyAdditionalFields: companyAdditionalFieldsReducer,
});

const middleware = [thunk];

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export type RootState = ReturnType<typeof rootReducer>;
export default store;
